<template>
    <ol>
        <AgendaListItemView
            v-for="item in items"
            :item="item"
            :selected_item="selected_item"
            @item_selected="(i) => $emit('item_selected', i)"
            :key="'agenda' + item.id"
            :level="level"
            :ignore_thumbnails="true"
            :include_user_notes="false"
            :no_docs="false"
            :read_only="read_only"
            :meeting="meeting"
        ></AgendaListItemView>
    </ol>
</template>

<script>

export default {
    name: "AgendaList",
    props: {
        'items': {},
        'selected_item': { default: null },
        'level': {},
        'ignore_thumbnails': { default: false },
        'include_user_notes': { default: false },
        'no_docs': { default: false },
        'read_only': { default: false },
        'meeting': {},
    }
}

</script>
